import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ActivatePersonsModel } from 'src/app/models/person/activate-persons.model';
import { ProfileModel } from 'src/app/models/profile.model';
import { LoadingService } from 'src/app/services/loading.service';
import { PersonService } from 'src/app/services/person.service';

@Component({
  selector: 'app-activate-all-users-modal',
  standalone: false,
  templateUrl: './activate-all-users-modal.component.html',
  styleUrl: './activate-all-users-modal.component.scss'
})
export class ActivateAllUsersModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  @Input() 
  persons: {id: string}[] = [];

  @Output() onCancel = new EventEmitter();
  @Output() onActivate = new EventEmitter();

  cancelButtonOptions: any;
  activateButtonOptions: any;

  constructor(
    private personService: PersonService,
    private loadingService: LoadingService,
    private toastrService: ToastrService,
    private translateService: TranslateService,
  ){
    
  }

  ngOnInit() {
    this.cancelButtonOptions = {
      stylingMode: 'contained',
      type: 'danger',
      text: this.translateService.instant('COMMON.CANCEL'),
      onClick: () => this.cancel()
    };

    this.activateButtonOptions = {
      stylingMode: 'contained',
      type: 'normal',
      text: this.translateService.instant('COMMON.ACTIVATE-ALL'),
      onClick: () => this.activate()
    };
  }

  activate() {
    const personIds = this.persons.map(p => p.id);
    const model: ActivatePersonsModel = {
      personIds: personIds
    };

    this.loadingService.load(
      this.personService.activeMultiplePersons(model)
    ).subscribe(() => {
      this.toastrService.success(
        this.translateService.instant('ACTIVATE-USERS.ACTIVATED-ALL-USERS-SUCCESSFULLY')
      );

      this.onActivate.emit();
      this.close();
    });
  }
   
  cancel(){
    this.onCancel.emit();
    this.close();
  }

  private close() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
